import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/login',
    //   component: ()=>import( './views/login.vue')
    // },
    // {
    //   path: '/register',
    //   component: ()=>import( './views/register.vue')
    // },
    {
      path: '/menu',
      component: ()=>import( './views/menu.vue')
    },

    {
      path: '/myorders',
      component: ()=>import( './views/myorders.vue')
    },
    {
      path: '/orderstatus/:id',
      component: ()=>import( './views/orderstatus.vue')
    },
    {
      path: '/pay/:price',
      component: ()=>import( './views/pay.vue')
    },
    {
      path: '/holdon',
      component: ()=>import( './views/holdon.vue')
    },
    {
      path: '/paydone',
      component: ()=>import( './views/paydone.vue')
    },
    {
      path: '/submitorder',
      component: ()=>import( './views/submitorder.vue')
    },
  ]
})
